<template>
    <transition name="slide-up">
      <div
        v-if="show"
        :class="[
          'fixed left-1/2 -translate-x-1/2 bottom-6 z-[9999] px-4 py-3 rounded-lg shadow-lg text-white outline-none',
          type === 'error' ? 'bg-red-600' : 'bg-emerald-600',
          clickable ? 'cursor-pointer hover:opacity-95 focus:ring-2 focus:ring-white/60' : ''
        ]"
        role="status"
        aria-live="polite"
        :tabindex="clickable ? 0 : -1"
        @click="handleClick"
        @keydown.enter.prevent="handleClick"
        @keydown.space.prevent="handleClick"
      >
        <span class="font-semibold">{{ message }}</span>
        <span v-if="clickable" class="ml-2 opacity-90">→</span>
      </div>
    </transition>
  </template>
  
  <script>
  export default {
    name: "AppToast",
    props: {
      type: { type: String, default: "success" },  // 'success' | 'error'
      message: { type: String, default: "" },
      show: { type: Boolean, default: false },
      clickable: { type: Boolean, default: false },
      // puedes pasar string (ruta) o un objeto de ruta { name: 'PacientesProspectos' }
      to: { type: [String, Object], default: null }
    },
    methods: {
      handleClick() {
        if (!this.clickable) return;
        // Permite que el padre escuche el click si quiere
        this.$emit('click');
  
        // Redirección directa si viene la prop "to"
        if (this.to && this.$router) {
          this.$router.push(this.to);
        }
      }
    }
  };
  </script>
  
  <style>
  .slide-up-enter-active, .slide-up-leave-active { transition: all .25s ease }
  .slide-up-enter-from, .slide-up-leave-to { opacity: 0; transform: translate(-50%, 16px); }
  </style>
  